export const constants: Constant[] = [
  { name: "e", aliases: ["e", "E"], value: Math.E },
  { name: "Infinity", aliases: ["Infinity"], value: Infinity },
  { name: "LN2", aliases: ["LN2"], value: Math.LN2 },
  { name: "LN10", aliases: ["LN10"], value: Math.LN10 },
  { name: "LOG2E", aliases: ["LOG2E"], value: Math.LOG2E },
  { name: "LOG10E", aliases: ["LOG10E"], value: Math.LOG10E },
  { name: "NaN", aliases: ["NaN"], value: NaN },
  { name: "pi", aliases: ["pi", "PI"], value: Math.PI },
  { name: "SQRT1_2", aliases: ["SQRT1_2"], value: Math.SQRT1_2 },
  { name: "SQRT2", aliases: ["SQRT2"], value: Math.SQRT2 },
  { name: "phi", aliases: ["phi"], value: (1 + Math.sqrt(5)) / 2 },
  { name: "null", aliases: ["null"], value: null },
  { name: "undefined", aliases: ["undefined"], value: undefined },
  { name: "tau", aliases: ["tau"], value: Math.PI * 2 },
];
export type Constant = {
  name: string;
  aliases: string[];
  value: number | null | undefined;
};
